import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { numberD, numberToCurrency } from 'src/smoothr-web-app-core/utils/utils';
import Order from '../../../smoothr-web-app-core/models/Order';
import { OrderUtils } from '../../../smoothr-web-app-core/utils/order-utils';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { AddCustomTipComponent } from '../add-custom-tip/add-custom-tip.component';
import { DefaultTip, TipsEnum } from 'src/smoothr-web-app-core/models/Tip';
import Venue from 'src/smoothr-web-app-core/models/Venue';
import { isRecalculartedOrder } from '../checkout-modal/checkout-modal.component';

@Component({
	selector: 'app-tip',
	templateUrl: './tip.component.html',
	styleUrls: ['tip.component.scss'],
	standalone: false,
})
export class TipComponent implements OnInit {
	@Output()
	tip = new EventEmitter<number>();

	percents = [5, 10, 15];
	tipsValues: DefaultTip[] = [];
	numberToCurrency = numberToCurrency;
	numberD = numberD;

	private modalCtrl: ModalController = inject(ModalController);
	private translate: TranslateService = inject(TranslateService);

	constructor() {}
	public ifTipsEnabled = false;
	public customTipsEnter = false;
	private _totalPrice: number;
	private _venue: Venue;
	get totalPrice(): number {
		return this._totalPrice;
	}

	set totalPrice(value: number) {
		if (this._totalPrice === value) {
			return;
		}
		this._totalPrice = value;
		this.recalculateAndEmitTip();
	}

	private _order: Order;

	get order(): Order {
		return this._order;
	}
	@Input()
	set venue(venue: Venue) {
		this._venue = venue;
		this.checkIfAvailable();
	}
	@Input()
	set order(order: Order) {
		this._order = order;
		if (isRecalculartedOrder(order)) {
			this.totalPrice = +order.totalPrice;
		} else {
			this.totalPrice = OrderUtils.orderTotalPrice(order, true, true);
		}
	}

	get currency(): string {
		return this.order && this.order.currency;
	}

	private _customTip: number;

	get customTip(): number {
		return this._customTip;
	}

	set customTip(value: number) {
		this._customTip = value;
		this.recalculateAndEmitTip();
	}

	private _selectedPercent: DefaultTip = null;

	get selectedPercent(): DefaultTip {
		return this._selectedPercent;
	}

	set selectedPercent(percent: DefaultTip) {
		this._selectedPercent = percent;
		this.recalculateAndEmitTip();
	}

	ngOnInit() {
		this.checkIfAvailable();
	}

	async showCustomPicker(): Promise<number> {
		let customTipValue =
			this.customTip && this.customTip.toString().includes('.')
				? this.customTip.toString().replace('.', ',')
				: this.customTip
					? this.customTip.toString()
					: '';
		let result = await AddCustomTipComponent.show(this.modalCtrl, customTipValue);
		if (!result) {
			return -1;
		}
		const selectedValue = Number(result.toString().replace(',', '.'));
		this.customTip = selectedValue;
		this.selectedPercent = null;
		return selectedValue;
	}
	private checkIfAvailable() {
		console.log('checkIfAvailable', this._venue, this._order);

		if (this.ifTipsEnabled || !this._venue || !this._order) return;

		try {
			const { tips } = this._venue;
			const order = this._order;

			if (!tips?.length) return;

			const availableTips = tips.filter(
				tip => tip.enabled && tip.orderType === order.type && tip.subOrderTypes.includes(order.preorder.type)
			);

			if (!availableTips.length) return;

			const defaultTips = availableTips[0].defaultTips || [];

			this.tipsValues = defaultTips.filter(tip => {
				if (tip.type === TipsEnum.ANY) {
					this.customTipsEnter = true;
					return false;
				}
				return true;
			});

			this.ifTipsEnabled = true;

			this.tipsValues.forEach(tip => {
				if (tip.isDefault) this.select(tip);
			});

			this.tipsValues = [...this.tipsValues];
		} catch (e) {
			this.ifTipsEnabled = false;
			this.tipsValues = [];
		}
	}
	recalculateAndEmitTip() {
		if (this.customTip) {
			this.tip.emit(this.customTip);
			return;
		}
		// console.log(this.selectedPercent?.value.$numberDecimal);
		// console.log(numberD(this.selectedPercent?.value) * 100);
		if (this.selectedPercent && this.selectedPercent?.value) {
			const customTipsCalc =
				this.selectedPercent?.type === TipsEnum.RELATIVE
					? +(this.totalPrice * numberD(this.selectedPercent.value))
					: numberD(this.selectedPercent.value);
			this.tip.emit(customTipsCalc);
			return;
		}

		this.tip.emit(0);
		return;
	}

	select(percent: DefaultTip) {
		try {
			if (
				this.selectedPercent?.type === percent?.type &&
				numberD(this.selectedPercent?.value) === numberD(percent.value)
			) {
				this.selectedPercent = null;
			} else {
				this.selectedPercent = percent;
			}
			this.customTip = 0;
		} catch (e) {
			this.customTip = 0;
		}
	}

	deleteTips() {
		this.selectedPercent = null;
		this.tip.emit(0);
	}

	getSumFromPercent(percent: DefaultTip) {
		return numberToCurrency(this.totalPrice * numberD(percent.value), this.currency);
	}

	getPercentValue(data: DefaultTip) {
		if (data.type === TipsEnum.RELATIVE) {
			return numberD(data.value) * 100;
		}

		return '';
	}
}
